import React , { useContext } from 'react';
import { ThemeContext } from 'styled-components'
import styled from 'styled-components'
import { makeStyles } from '@material-ui/core/styles';
import CircularProgress from '@material-ui/core/CircularProgress';
import { useSpring, animated } from 'react-spring'

const Page = styled(animated.div)`
  background: #eff0f1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
`;

const Message = styled.h2`
  color: #595959;
  font-weight: 400;
  margin-top: 32px;
`;

const Loading = (props) => {
  const theme = useContext(ThemeContext)
  const useStyles = makeStyles(materialTheme=> ({
    buttonProgress: {
      color: theme.color.primary,
    },
  }));
  const classes = useStyles();
  const fadeAnimation = useSpring({ opacity: 1, from: { opacity: 0 } })
  return (
    <Page style={fadeAnimation}>
      <CircularProgress className={classes.buttonProgress} size={64}/>
      <Message>
        Loading portal profile...
      </Message>
    </Page>
  )
}


export default Loading
